export const isObject = (x) => {
    return Object.prototype.toString.call(x) === "[object Object]";
};
export var AnnotationType;
(function (AnnotationType) {
    AnnotationType["Info"] = "INFO";
    AnnotationType["Warning"] = "WARNING";
    AnnotationType["Error"] = "ERROR";
    AnnotationType["Debug"] = "DEBUG";
})(AnnotationType || (AnnotationType = {}));
export var UserRoleType;
(function (UserRoleType) {
    UserRoleType["Owner"] = "OWNER";
    UserRoleType["Editor"] = "EDITOR";
    UserRoleType["Contributor"] = "CONTRIBUTOR";
    UserRoleType["Viewer"] = "VIEWER";
    UserRoleType["None"] = "NONE";
})(UserRoleType || (UserRoleType = {}));
export var RecordType;
(function (RecordType) {
    RecordType["NotDeleted"] = "NOT_DELETED";
    RecordType["Deleted"] = "DELETED";
    RecordType["Archive"] = "ARCHIVE";
})(RecordType || (RecordType = {}));
export var CommentableType;
(function (CommentableType) {
    CommentableType["COMMENT"] = "COMMENT";
    CommentableType["PROJECT_ASSUMPTION"] = "PROJECT_ASSUMPTION";
    CommentableType["PROJECT_SCENARIO"] = "PROJECT_SCENARIO";
    CommentableType["PROJECT_SEGMENT_ASSUMPTION"] = "PROJECT_SEGMENT_ASSUMPTION";
    CommentableType["PROJECT_TASK"] = "PROJECT_TASK";
    CommentableType["TRAINING"] = "TRAINING";
    CommentableType["REPORT"] = "REPORT";
    CommentableType["REPORT_CHART"] = "REPORT_CHART";
})(CommentableType || (CommentableType = {}));
